/**
 * Story Template Init (Universal)
 * Entry point for ALL story templates (scroll & slide)
 * Depends on: story-core.js, story-module-panel-reveal.js, story-module-video-autoplay.js, story-module-active-panel.js
 */

(function (window) {
  'use strict';

  // Check for universal templates (NEW)
  var templateRoot = document.querySelector('[data-story-template="scroll"]') ||
                     document.querySelector('[data-story-template="slide"]') ||
                     // Backward compatibility for old templates
                     document.querySelector('[data-story-template="scrolly-video"]') ||
                     document.querySelector('[data-story-template="slides-video"]');

  if (!templateRoot) {
    return;
  }

  var templateType = templateRoot.dataset.storyTemplate;

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    // Check if dependencies are loaded
    if (typeof window.StoryCore === 'undefined') {
      console.error('Story Template: StoryCore not found. Make sure story-core.js is loaded first.');
      return;
    }

    if (typeof window.StoryModulePanelReveal === 'undefined') {
      console.error('Story Template: PanelReveal module not found.');
      return;
    }

    if (typeof window.StoryModuleVideoAutoplay === 'undefined') {
      console.error('Story Template: VideoAutoplay module not found.');
      return;
    }

    if (typeof window.StoryModuleActivePanel === 'undefined') {
      console.error('Story Template: ActivePanel module not found.');
      return;
    }

    // Check for Panorama 360 module (optional)
    var hasPanoramaModule = typeof window.StoryModulePanorama360 !== 'undefined';

    // Check for Hub/Kapitel module (optional)
    var hasHubModule = typeof window.StoryModuleHub !== 'undefined';

    // Initialize core system with detected template
    var selector = '[data-story-template="' + templateType + '"]';
    var core = new window.StoryCore(selector);

    if (!core.root) {
      console.warn('Story Template: Template root not found');
      return;
    }

    // Initialize modules
    new window.StoryModulePanelReveal(core);
    new window.StoryModuleVideoAutoplay(core);
    new window.StoryModuleActivePanel(core);

    // Initialize Panorama 360 module (if available)
    if (hasPanoramaModule) {
      new window.StoryModulePanorama360(core);
    }

    // Initialize Hub/Kapitel module (if available)
    if (hasHubModule) {
      new window.StoryModuleHub(core);
    }

    // Check for VideoScroll module (optional)
    var hasVideoScrollModule = typeof window.StoryModuleVideoScroll !== 'undefined';

    // Initialize VideoScroll module (if available)
    if (hasVideoScrollModule) {
      new window.StoryModuleVideoScroll(core);
    }

    // Check for MapScroll module (optional)
    var hasMapScrollModule = typeof window.StoryModuleMapScroll !== 'undefined';
    if (hasMapScrollModule) {
      new window.StoryModuleMapScroll(core);
    }

    // Check for Gallery module (optional)
    var hasGalleryModule = typeof window.StoryModuleGallery !== 'undefined';
    if (hasGalleryModule) {
      new window.StoryModuleGallery(core);
    }

    // Check for SplitScroll module (optional)
    var hasSplitScrollModule = typeof window.StoryModuleSplitScroll !== 'undefined';
    if (hasSplitScrollModule) {
      new window.StoryModuleSplitScroll(core);
    }

    // Check for StickyScene module (optional)
    var hasStickySceneModule = typeof window.StoryModuleStickyScene !== 'undefined';
    if (hasStickySceneModule) {
      new window.StoryModuleStickyScene(core);
    }

    // Check for ImgScroll module (optional)
    var hasImgScrollModule = typeof window.StoryModuleImgScroll !== 'undefined';
    if (hasImgScrollModule) {
      new window.StoryModuleImgScroll(core);
    }

    // Check for Ambient Audio module (optional)
    var hasAmbientModule = typeof window.StoryModuleAmbient !== 'undefined';
    if (hasAmbientModule) {
      var ambient = new window.StoryModuleAmbient();
      ambient.init();
      window.storyAmbient = ambient;
    }

    // Check for Panel-Ambient module (optional) — per-panel looping ambience with crossfade
    var hasPanelAmbientModule = typeof window.StoryModulePanelAmbient !== 'undefined';
    if (hasPanelAmbientModule) {
      var panelAmbient = new window.StoryModulePanelAmbient();
      panelAmbient.init();
      window.storyPanelAmbient = panelAmbient;
    }

    // Expose core globally (needed for story-loader.js to detect initialization)
    window.storyCore = core;

    // Test hook — expose internals for Playwright unit tests
    if (window.location.search.indexOf('__test__') !== -1) {
      window.__storyTest__ = {
        core: core,
        api: window.StoryAPI,
        mediaManager: window.StoryMediaManager,
        modules: core.modules,
        clamp: core.clamp.bind(core),
        get activePanel() { return window.storyActivePanel; },
        get activeIndex() { return window.storyActiveIndex; },
        get templateType() { return core.templateType; },
        get hasReducedMotion() { return core.hasReducedMotion; }
      };
    }

    // Debug logging
    if (window.location.search.indexOf('debug=story') !== -1) {
      console.log('Story Core Debug Mode (' + templateType + '):', core);
    }
  }

})(window);
